import { VueI18nHelper } from '@/helpers/VueI18nHelper';
import AnnouncementBar from './AnnouncementBar.vue';
import '../../assets/styles/rin-global.less';
import '../../assets/styles/rin-table.less';
import '../../assets/styles/rin-settings.less';
import config from '../../../config';

VueI18nHelper.initVueI18NextMultipleForPage(
  AnnouncementBar,
  `.announcementbar-vue`,
  [config.locize.announcementBar.namespaces.UFE, config.locize.frontPage.namespaces.FRONTPAGE],
  [
    {
      projectId: config.locize.announcementBar.PROJECTID,
      version: config.locize.announcementBar.version,
    }, {
      projectId: config.locize.frontPage.PROJECTID,
      version: config.locize.frontPage.version,
    },
  ],
);
